import { render } from "./DataAnalysis.vue?vue&type=template&id=112dc8fd&scoped=true"
import script from "./DataAnalysis.vue?vue&type=script&lang=js"
export * from "./DataAnalysis.vue?vue&type=script&lang=js"

import "./DataAnalysis.vue?vue&type=style&index=0&id=112dc8fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112dc8fd"]])

export default __exports__